export default "__VITE_ASSET__FdYM2cOG__"